import axios from 'axios';
import { useStore } from "@/store/index";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000 // request timeout
});
service.interceptors.request.use(config => {
  const store = useStore();
  const token = store.$state.token;
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
}, error => {
  return Promise.reject(error);
});
service.interceptors.response.use(response => {
  return response.data;
}, error => {
  const {
    status,
    data
  } = error.response;
  showToast(data);
  if (status == 401) {
    setTimeout(() => {
      location.replace(location.origin + '/#/login');
      localStorage.removeItem('token');
    }, 1000);
  }
  return Promise.reject();
});
export default service;